import { Breadcrumbs, Chip, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { NavLink } from "react-router-dom";

import { KeyIcon } from "@phosphor-icons/react/dist/csr/Key";
import { CREDENTIAL_TYPES } from "../../../components/KeyEditor/KeyEditor";

type PageHeaderProps = {
  keyName?: string;
  keyType: string;
  breadcrumbsInformation: BreadcrumbsInformation[];
};

export type BreadcrumbsInformation = {
  name: string;
  link?: string;
  "data-testid"?: string;
};

type PageBreadcrumbsProps = {
  breadcrumbsInformation: BreadcrumbsInformation[];
};

const PageBreadcrumbs = ({ breadcrumbsInformation }: PageBreadcrumbsProps) => {
  const lastBreadcrumb = breadcrumbsInformation.pop();

  return (
    <Breadcrumbs>
      {breadcrumbsInformation.map((breadcrumb) => (
        <NavLink to={breadcrumb.link || ""} key={breadcrumb.name} data-testid={breadcrumb["data-testid"]}>
          <Typography variant="body.overline.regular">{breadcrumb.name}</Typography>
        </NavLink>
      ))}

      <Typography variant="body.overline.bold">{lastBreadcrumb?.name}</Typography>
    </Breadcrumbs>
  );
};

const KeyPageHeader = ({ keyName, keyType, breadcrumbsInformation }: PageHeaderProps) => {
  const keyDisplayName = CREDENTIAL_TYPES[keyType as keyof typeof CREDENTIAL_TYPES]?.display_name;
  return (
    <>
      <PageBreadcrumbs breadcrumbsInformation={breadcrumbsInformation} />
      <Stack direction="row" spacing={1} sx={{ alignItems: "flex-end", paddingBottom: "20px" }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <KeyIcon size={32} />
          {keyName && <Chip variant="outline" label={keyDisplayName} data-testid="key-type-chip" />}
        </Stack>
        <Typography variant="heading.three" sx={{ paddingLeft: "12px" }}>
          {keyName || keyDisplayName}
        </Typography>
      </Stack>
    </>
  );
};

export { KeyPageHeader };
